import { render, staticRenderFns } from "./purchaser_home.vue?vue&type=template&id=11333e77"
import script from "./purchaser_home.vue?vue&type=script&lang=js"
export * from "./purchaser_home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports